var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38238 6.22032C4.14831 6.46111 4.14626 6.82871 4.38238 7.068L6.9754 9.66103C7.53344 10.2191 8.38112 9.37138 7.82308 8.81335L6.25343 7.24369H15.1939C15.9832 7.24369 15.9832 6.04482 15.1939 6.04482H6.25343L7.82308 4.47516C8.38112 3.91713 7.53344 3.06927 6.9754 3.62748L4.38238 6.22032ZM12.177 15.5245L13.7466 13.9548H4.80613C4.01682 13.9548 4.01682 12.7559 4.80613 12.7559H13.7466L12.177 11.1863C11.6189 10.6283 12.4666 9.78058 13.0247 10.3386L15.6179 12.9314C15.8514 13.1683 15.849 13.5389 15.6287 13.7681L13.0248 16.3723C12.4666 16.9302 11.6189 16.0825 12.177 15.5245Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.16254825696a4201eec80e8a292c9b8d.svg";
export { ForwardRef as ReactComponent };